import { PROGRESS_START, PROGRESS_FINISH } from "../../mutation-types";
import edcApi from "../../../api/edc";

const defaultState = () => ({
	edc: [],
	bank: [],
	konfirmResponse: {},
	responSukses: '',
});

const state = defaultState();

const getters = {};

const mutations = {
	listEdc(state, data) {
		state.edc = []
		state.edc = data;
	},
	listBank(state, data) {
		state.bank = []
		state.bank = data;
	},
	saveConfirmResponse(state, data) {
		state.konfirmResponse = {};
		state.konfirmResponse = data;
	},
	konfirmasiSukses(state, data) {
		state.responSukses = '';
		state.responSukses = data;
	},
};
const actions = {
	getEdc({ commit }) {
		commit(PROGRESS_START, null, { root: true });
		edcApi.getDataEdc().then(({ data: { data: { results } } }) => {

			if (results.length == 0) {
				commit('listEdc', 'error');
			} else {
				commit("listEdc", results);
			}
			commit(PROGRESS_FINISH, null, { root: true });
		});
	},
	getBank({ commit }) {
		commit(PROGRESS_START, null, { root: true });
		edcApi.getDataBank().then(({ data: { data: { results } } }) => {
			commit("listBank", results)

			commit(PROGRESS_FINISH, null, { root: true });
		});
	},
	async addPembayaranEdc({ commit }, value) {
		commit("konfirmasiSukses", '');
		commit(PROGRESS_START, null, { root: true });
		await edcApi.addPembayaranEdc(value).then(res => {
			const data = res.data.code;
			commit("konfirmasiSukses", data);
		})
		.catch(err => {
			const data = err.response.data.data
			commit("saveConfirmResponse", data);
		});
	},
	async updatePembayaranEdc({ commit }, value) {
		commit("konfirmasiSukses", '');
		commit(PROGRESS_START, null, { root: true });
		await edcApi.updatePembayaranEdc(value).then(res => {
			const data = res.data.code;
			commit("konfirmasiSukses", data);
		})
		.catch(err => {
			const data = err.response.data.data
			commit("saveConfirmResponse", data);
		});
	},
	async deletePengaturanEdc({ commit }, value) {
		commit(PROGRESS_START, null, { root: true });
		await edcApi.deletePembayaranEdc(value).then(res => {
			const data = res.data.code;
			commit("konfirmasiSukses", data);
		})
		.catch(err => {
			const data = err.response.data.data
			commit("saveConfirmResponse", data);
		});
	},

};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};